<template>
  <div>
    <vxe-toolbar
      id="toolbarId_ca42"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('WithdrawalRecord_search_button')"
          @click="funcFilter"
        >查询</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      border
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="550"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="serialNo"
          title="外部流水号"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.serialNo"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="recAccNo"
          title="收款账户"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.recAccNo"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="amount"
          title="提现金额（元）"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.amountStart"
                placeholder="下限"
                clearable
                @input="(value)=>formFormatter.isFloor2(value,oldValue,listQuery,'amountStart')"
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.amountEnd"
                placeholder="上限"
                clearable
                @input="(value)=>formFormatter.isFloor2(value,oldValue,listQuery,'amountEnd')"
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="提现时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="(value) => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="提现状态"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'status')
          "
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" placeholder="请选择" clearable>
            <el-option
              v-for="item in parentData.statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="150" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('AWithdrawalRecord_update_button')&& (scope.row.status == 0 || scope.row.status == 3)"
            class="item"
            effect="dark"
            content="更新提现结果"
            placement="top"
          >
            <vxe-button type="text" @click="updateWithdraw(scope.row)">
              <i class="el-icon-refresh" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import {
  ArpaWithdrawRecord,
  updateWithdrawRecord,
} from "@/api/collectioncoding";
export default {
  name: "CompRecord",
  data() {
    return {
      loading: false,
      dialog: false,
      tableData: [],
      parentData: {},
      emptyForm: {},    
      listQuery: {    
        serialNo: "",
        partyCode:"",
        gmtCreatedRange: "", 
        recAccNo: "",
        amountStart: "",
        amountEnd: "",
        gmtCreatedStart: "",
        gmtCreatedEnd: "",
        pageNum: 1, 
        pageSize: 10,
        sortField: "",
        sortType: "",
        total: 0,
      },
      initQuery:{},
      auditMethod: "0",
    };
  },
  created() {
    this.parentData.statusOptions = [
      { value: 0, label: "处理中" },
      { value: 1, label: "打款成功" },
      { value: 2, label: "打款失败" },
      { value: 3, label: "交易状态未知" },
    ];
  },
  methods: {
    findList(code) {
    //   this.listQuery.partyCode = code; 
      if (code) {
        this.listQuery = JSON.parse(this.initQuery);
        this.listQuery.partyCode = code
        this.initQuery = JSON.stringify(this.listQuery)
      }
      this.loading = true;
      return new Promise((resolve) => {
        ArpaWithdrawRecord(this.listQuery).then((response) => {
          this.tableData = response.data.records;
          // response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    //支付状态查询
    updateWithdraw(item) {
      let code = item.code;
      updateWithdrawRecord({ code }).then((response) => {
        this.$message({
          message: response.msg,
          type: "success",
        });
        this.findList();
      });
    },
    // 翻译
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        (item) => item.value === cellValue
      );
      return item ? item.label : "";
    },
    cancelForm() {
      this.loading = false;
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
}
::v-deep.el-dialog {
  margin: 0 auto !important;
  height: 60%;
  width: 32%;
  overflow: hidden;
}
::v-deep .el-dialog .el-dialog__body {
  position: absolute;
  left: 10px;
  top: 58px;
  bottom: 0;
  right: 0;
  padding: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: auto;
}
</style>
